import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { stripeConnectRef } from './consts';

export default grapesjs.plugins.add('gjs-stripe-connect-buy', (editor, opts) => {
  let c = opts || {};

  let defaults = {
    pfx: 'stripe-connect-buy',
    blocks: [stripeConnectRef],
    defaultStyle: true,
    labelStripeConnectBuyCategory: 'Payment Gateway',
    labelStripeConnectBuy: 'Stripe: Buy Now',
  };

  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  loadComponents(editor, c);
  loadBlocks(editor, c);
});
